<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.angle_rotation}}</h3>
</div>
<div class="modal-body">
    <form class="form-signin" style="max-width:400px">
        <div class="row">
			<div class="col-xs-12 col-sm-6">
				<p id="angleLabel" class="text-black">{{LOCALIZATION.angle_rotation_tooltip}} </p>
				<select type="text" class="form-control" [(ngModel)]="angle" name="angleSelect" aria-labelledby="angleLabel">
					<option value="90">{{LOCALIZATION.rotate90Right}}</option>
					<option value="270">{{LOCALIZATION.rotate90Left}}</option>
					<option value="180">{{LOCALIZATION.rotate180}}</option>
					<option value="-1">{{LOCALIZATION.auto}}</option>
				</select>
			</div>
        </div>
    </form>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.cancel}}</button>
    <button class="btn btn-primary" type="button" (click)="rotate()" [disabled]="inprogress">
    	<i class="fas fa-spinner fa-spin fa-fw" [hidden]="!inprogress"></i>
    	{{LOCALIZATION.rotate}}
    </button>
</div>